import { Link, Outlet } from 'react-router-dom'
import React from 'react'
import { useWindowSize } from '~/common/hooks/useWindowSize'

const LoginBackground = () => {
  const { isCondensedPortrait } = useWindowSize()

  return (
    <div className={'login-background'}>
      <Outlet />
      <footer className={'login-page'}>
        {!isCondensedPortrait && <a href={'https://veeva.com'} target={'_blank'} className={'veeva-logo'} />}
        <div className={`link-area ${isCondensedPortrait ? 'condensed' : ''}`}>
          {!isCondensedPortrait && (
            <>
              <span>
                <a href={'https://veeva.com'} target={'_blank'}>
                  Veeva.com
                </a>
              </span>
              <span>&middot;</span>
            </>
          )}
          <span>
            <Link to={'/terms'} target="_blank">
              Terms of Use
            </Link>{' '}
            and{' '}
            <Link to={'/privacy-policy'} target="_blank">
              Privacy Policy
            </Link>
          </span>
          <span>&middot;</span>
          <span>
            <a href={'mailto:veevaconnect@veeva.com'}>Contact Us</a>
          </span>
        </div>
      </footer>
    </div>
  )
}

export default LoginBackground
